import { SchemaOf, object, string } from 'yup';

import { REQUIRED_FIELD } from '@/config/text.const';

export interface Fields {
  billingType: string;
}

export type CustomerOption = { label: string; value: string };

export const validationSchema: SchemaOf<Fields> = object().shape({
  billingType: string().required(REQUIRED_FIELD),
});
